<template>
    <section v-if="internalBasicData !== null && votingPossibleAnswers !== null" :id="interactiveVotingResultModalId" class="voting" :class="{'voting-public': isPublicView }"> 
        <div class="voting-form">
 
            <section class="voting-form__form-wrapper">
                <section class="voting-form__title">
                    <span v-if="internalBasicData.isCheckPresence == true">
                        {{$t('com.file.interactive-voting-results.results-from-day')}} {{formatDateToDisplay(internalBasicData.sessionDateTime)}}: <b>{{ shrinkVotingName(internalBasicData.name) }}</b>
                    </span>
                    <span v-else>
                        {{$t('com.file.interactive-voting-results.voting-results')}} <span style="text-decoration:underline">{{internalBasicData.isPublic ? $t('com.file.interactive-voting-results.public-voting') : $t('com.file.interactive-voting-results.secret-voting')}}</span> {{$t('com.global.from-day')}} {{formatDateToDisplay(internalBasicData.sessionDateTime)}}: <b>{{ shrinkVotingName(internalBasicData.name) }}</b>
                    </span>
                    <section class="d-flex flex-row">
                        <ButtonWithIcon v-if="!isPublicView" icon="download" class="download-button"
                                        text=".PDF"
                                        :classModified="true"
                                        @click="getPdfReport()" />

                        <ButtonWithIcon v-if="!isPublicView" icon="download" class="download-button"
                                        text=".DOC"
                                        :classModified="true"
                                        @click="getDocReport()" />

                        <ButtonOnlyWithIcon v-if="!votingIsRunning && !showResultsInVisualizationWindow && isInteractive()" @click="showResultsVisualization()" class="download-button-eye" icon="eye" v-tooltip.bottom="$t('com.file.interactive-voting-results.show-results-in-ow')" />
                        <ButtonOnlyWithIcon v-if="!votingIsRunning && showResultsInVisualizationWindow && isInteractive()" @click="hideResultsVisualization()" class="download-button-eye" icon="eye2" v-tooltip.bottom="$t('com.file.interactive-voting-results.hide-results-in-ow')" />

                        <button class="voting-form__exit-btn" v-tooltip="$t('com.file.interactive-voting-results.close-window')"
                                v-if="canClose" @click="closeModale">
                            <img src="@/assets/icons/components/exit-btn.svg" />
                        </button>
                    </section>
                </section>

                <!-- normal voting result-->
                <div v-if="internalBasicData.gType != 4">
                    <div class="summary">
                        <div :class="[internalBasicData.isPublic ? 'summary__row-double' : '']">
                            <section :class="[internalBasicData.isPublic ? 'summary__col-double' : '']" v-if="$store.state.settings.runtime.chartType < 4">
                                <Chart :chartData="chartData" :plugins="plugins" :options="options" :height="250" :type="$store.state.settings.runtime.chartType" />
                            </section>
                            <section class="summary__col-double" :class="{'result-without-chart': $store.state.settings.runtime.chartType >= 4}">
                                <div class="results">
                                    <div class="upr-res">
                                        <b>{{$t('com.file.interactive-voting-results.summary')}}: </b>
                                        <div class="uprawniony" :class="optionToClassName(s.option)" v-for="s in votingPossibleAnswers.options" :value="s.id" :key="s.id">{{s.option}}: <b>{{s.count}}</b></div>
                                    </div>
                                </div>
                                <perfect-scrollbar class="scroll-user-answers">
                                    <section v-if="internalBasicData.isPublic">
                                        <h2 class="msg-result">{{$t('com.file.interactive-voting-results.users-list')}}</h2>
                                        <div class="available-users">
                                            <div class="user" v-for="(item, key) in [...new Map(votingPossibleAnswers.users.map((item) => [item['userId'], item])).values()]" :key="key" :class="getVoteUserClass(item)">
                                                <div class="user-data">
                                                    <span class="user-name">{{item.firstName}} {{item.lastName}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section v-if="votingPossibleAnswers.excluded_users != null && votingPossibleAnswers.excluded_users.length > 0">
                                        <p class="msg-result-excluted">{{$t('com.file.interactive-voting-results.excludes-from-voting')}}</p>
                                        <div class="available-users" style="justify-content: center;">
                                            <div class="user excluded" v-for="(item, key) in [...new Map(votingPossibleAnswers.excluded_users.map((item) => [item['userId'], item])).values()]" :key="key">
                                                <div class="user-data">
                                                    <span class="user-name">{{item.firstName}} {{item.lastName}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </perfect-scrollbar>
                                <VotingResultMessage v-if="votingPossibleAnswers.msg_result != null" :msg_result="votingPossibleAnswers.msg_result" />
                            </section>
                        </div>
                    </div>
                </div>

                <!-- special voting result-->
                <div v-if="internalBasicData.gType == 4" class="voting-special-wrapper">
                    <div class="summary">
                        <div :class="[internalBasicData.isPublic ? 'summary__row-double' : '']">
                            <section :class="[internalBasicData.isPublic ? 'summary__col-double' : 'summary__col-single']">
                                <div class="upr-res-special">
                                    <b>{{$t('com.file.interactive-voting-results.summary')}}:</b>
                                    <div v-for="(s, index) in orderSpeciaVotingSummaryResults(votingPossibleAnswers.options)" class="option_summary" :value="s.id" :key="s.id">
                                        <div class="special_result_option">
                                            <span class="special_result__query">{{index+1}}. {{s.option}}:</span>
                                            <span class="special_result_option__row vote-yes-background d-flex flex-row"><span class="special_result_option__row__answer">{{$t('com.file.interactive-voting-public-modal.vote-yes')}}: </span><span class="special_result_option__row__count">{{s.for}}</span></span>
                                            <span class="special_result_option__row vote-no-background d-flex flex-row"><span class="special_result_option__row__answer">{{$t('com.file.interactive-voting-public-modal.vote-no')}}: </span><span class="special_result_option__row__count">{{s.against}}</span></span>
                                            <span class="special_result_option__row vote-abstain-background d-flex flex-row"><span class="special_result_option__row__answer">{{$t('com.file.interactive-voting-public-modal.vote-abstain')}}: </span><span class="special_result_option__row__count">{{s.abstain}}</span></span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section class="summary__col-double" style="position: sticky; top: 0px;">
                                <perfect-scrollbar class="scroll-user-answers">
                                    <section v-if="internalBasicData.isPublic" class="d-flex flex-column gap-2">
                                        <h2 class="msg-result">{{$t('com.file.interactive-voting-results.users-list')}}</h2>
                                        <div class="option-result d-flex flex-column gap-1" v-for="(s, key) in orderSpeciaVotingSummaryResults(votingPossibleAnswers.options)" :key="key">
                                            <div class="option-result__name"> {{ s.option }} ({{ s.for }})</div>
                                            <div class="available-users">
                                                <div class="user" v-for="(item, key) in specialVotingUserResult(s)" :key="key" :class="getVoteUserClass(item)">
                                                    <div class="user-data">
                                                        <span class="user-name">{{item.firstName}} {{item.lastName}} </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section v-if="votingPossibleAnswers.excluded_users != null && votingPossibleAnswers.excluded_users.length > 0">
                                        <p class="msg-result-excluted">{{$t('com.file.interactive-voting-results.excludes-from-voting')}}</p>
                                        <div class="available-users" style="justify-content: center;">
                                            <div class="user excluded" v-for="(item, key) in [...new Map(votingPossibleAnswers.excluded_users.map((item) => [item['userId'], item])).values()]" :key="key">
                                                <div class="user-data">
                                                    <span class="user-name">{{item.firstName}} {{item.lastName}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </perfect-scrollbar>
                            </section>
                        </div>
                    </div>
                </div>

            </section>
        </div>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script>
    import Chart from '../../../../BasicControls/Charts/Chart.vue';
    import LoaderInside from "../../../../BasicControls/LoaderInside.vue"
    import ButtonWithIcon from "../../../../BasicControls/ButtonWithIcon.vue";
    import ButtonOnlyWithIcon from "../../../../BasicControls/ButtonOnlyWithIcon.vue";
    import VotingService from "../../../../../services/voting.service";
    import PdfExportService from "../../../../../services/pdf.export.service";
    import VotingResultMessage from "./ComponentsParts/VotingResultMessage.vue"
    import { fileDownloadHelperWithName } from "@/helpers/file.download.helper";

    export default {
        name: "InteractiveVotingResults",
        data() {
            return {
                plugins: [{
                    options: {
                        legend: {
                            display: false
                        }
                    },
                }],
                options: {
                    legend: {
                        display: false
                    }
                },
                tempdata: [],
                isLoading: false,
                errors: [],
                votingIsRunning: false,
                votingPossibleAnswers: this.$store.state.votingStore.votingPossibleAnswersData,
                internalBasicData: this.$store.state.votingStore.votingInternalBasicData,
                hiddenVoteResult: 0,
                showResultsInVisualizationWindow: this.$store.state.votingStore.fromEndVotingCall,
                chartData: this.$store.state.votingStore.votingChartData,
                selectedSpecialVoting: null,
            };
        },
        components: {
            Chart,
            LoaderInside,
            ButtonWithIcon,
            ButtonOnlyWithIcon,
            VotingResultMessage
        },
        computed: {
            interactiveVotingResultModalId() {
                switch (this.$route.name) {
                    case 'sessionEdit':
                        return 'interactive-voting-result-modal-id';
                    case 'PublicSession':
                        return 'interactive-voting-result-modal-ow-id';
                    case 'PublicSessionInfo':
                        return 'interactive-voting-result-modal-public-id';
                    default:
                        return 'interactive-voting-result-modal-id';
                }
            },
            isPublicView() {
                return this.$store.state.votingStore.isPublicViewCall;
            },
            canClose() {
                return this.$store.state.votingStore.isCanClose;
            }
        },
        methods: {
            shrinkVotingName(text){
                if (text.length > 575) {
                    return text.slice(0, 575) + '...';
                }
                return text;
            },
            orderSpeciaVotingSummaryResults(options) {
                var sortedSpecialResult = [];
                sortedSpecialResult = options.filter(x => x.option !== this.$t('com.file.interactive-voting-public-modal.vote-lack') && x.option !== this.$t('com.file.interactive-voting-public-modal.vote-absent-prular') && x.option !== this.$t('com.file.interactive-voting-public-modal.vote-absent-singular')).sort((a, b) => (a.for < b.for) ? 1 : ((b.for < a.for) ? -1 : 0));
                
                return sortedSpecialResult;
            },
            specialVotingUserResult(option){
                const temp = this.votingPossibleAnswers.users.filter(x => x.responseId === option.id);
                return [...new Map(temp.map((item) => [item['userId'], item])).values()];
            },
            optionToClassName(option){
                switch (option) {
                    case this.$t('com.file.interactive-voting-public-modal.vote-for'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-yes'):
                        return "vote-for";
                    case this.$t('com.file.interactive-voting-public-modal.vote-against'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-no'):
                        return "vote-no";
                    case this.$t('com.file.interactive-voting-public-modal.vote-abstain'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-dont-know'):
                        return "vote-abstain";
                    case this.$t('com.file.interactive-voting-public-modal.vote-lack'):
                        return "vote-no-vote";
                    case this.$t('com.file.interactive-voting-public-modal.vote-absent-prular'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-absent-singular'):
                        return "vote-absent";
                    case this.$t('com.file.interactive-voting-public-modal.vote-excluded'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-excluded2'):
                        return "vote-exclude";
                    default:
                        return "vote-default";

                }
            },
            isInteractive() {
                return this.$store.state.appStore.isInInteractiveMode;
            },
            showResultsVisualization() {
                this.showResultsInVisualizationWindow = true;
                this.$store.commit("setIsResultsInVisualization", true)
            },
            hideResultsVisualization() {
                this.showResultsInVisualizationWindow = false;
                this.$store.commit("setIsResultsInVisualization", false)
            },
            async getPdfReport() {
                try {
                    this.$store.commit("showLoader");

                    const data = {
                        gid: this.internalBasicData.votingId,
                        isPublic: this.internalBasicData.isPublic,
                        mode: 1,
                        gtype: this.internalBasicData.gType,
                        date: this.formatDateToDisplayLong(this.internalBasicData.sessionDateTime),
                        name: this.internalBasicData.name
                    };

                    const result = await PdfExportService.getVotingSummaryPdfFile(data);
                    if (result.status === 200) {
                        var filename = result.headers['content-disposition'].split("filename=")[1];
                        filename = filename.substr(0, filename.indexOf(';'));
                        filename = filename.replaceAll('"', '');

                        fileDownloadHelperWithName(result, filename);
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }              
            },
            async getDocReport() {
                try {
                    this.$store.commit("showLoader");

                    var data = {
                        gid: this.internalBasicData.votingId,
                        isPublic: this.internalBasicData.isPublic,
                        mode: 1,
                        gtype: this.internalBasicData.gType,
                        date: this.formatDateToDisplayLong(this.internalBasicData.sessionDateTime),
                        name: this.internalBasicData.name
                    };

                    let result = await VotingService.getVotingSummaryToWordFile(data);
                    if (result.status == 200) {

                        const contentType = result.headers['content-type'];
                        let a = document.createElement('a');
                        var blob = new Blob([result.data], { 'type': contentType });
                        a.href = window.URL.createObjectURL(blob);
                        var filename = result.headers['content-disposition'].split("filename=")[1];

                        filename = filename.substr(0, filename.indexOf(';'));
                        filename = filename.replaceAll('"', '');
                        a.download = filename
                        a.click();
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            getVoteUserClass(item) {
                if (item === null)
                    return "";

                let userVoice = parseInt(item.response);
                // zakomentwany celowo
                if(this.internalBasicData.gType === 4){
                    userVoice = parseInt(item.option);
                }
                switch (userVoice) {
                    case 0: return "vote-lack";
                    case 1: return "vote-for";
                    case 2: return "vote-against";
                    case 3: return "vote-abstain";
                    case 4: return "absent";
                    case 20: return "excluded";
                    case 10:
                    case 99:
                        return "vote-hidden";
                }
            },
            formatDateToDisplay(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });

                return d;
            },
            formatDateToDisplayLong(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });

                return d;
            },
            formatAnswersColorText(result) {
                if (result == this.$t('com.file.interactive-voting-public-modal.vote-absent-prular') ||
                    result == this.$t('com.file.interactive-voting-public-modal.vote-absent-singular') ||
                    result == this.$t('com.file.interactive-voting-public-modal.vote-excluded') ||
                    result == this.$t('com.file.interactive-voting-public-modal.vote-against') ||
                    result == this.$t('com.file.interactive-voting-public-modal.vote-no'))
                    return 'white';
                else
                    return 'black';
            },
            formatAnswersDecorationText(result) {
                if (result == this.$t('com.file.interactive-voting-public-modal.vote-excluded2'))
                    return 'line-through';
                else
                    return 'none';
            },
            formatAnswersColor(result) {
                if (result != null) {
                    switch (result.option) {
                        case this.$t('com.file.interactive-voting-public-modal.vote-for'):
                        case this.$t('com.file.interactive-voting-public-modal.vote-yes'):
                            result.color = '#79e563';
                            break;
                        case this.$t('com.file.interactive-voting-public-modal.vote-against'):
                        case this.$t('com.file.interactive-voting-public-modal.vote-no'):
                            result.color = '#e40030';
                            break;
                        case this.$t('com.file.interactive-voting-public-modal.vote-abstain'):
                        case this.$t('com.file.interactive-voting-public-modal.vote-dont-know'):
                            result.color = '#ffce56';
                            break;
                        case this.$t('com.file.interactive-voting-public-modal.vote-lack'):
                            result.color = '#c0c0c0';
                            break;
                        case this.$t('com.file.interactive-voting-public-modal.vote-absent-prular'):
                        case this.$t('com.file.interactive-voting-public-modal.vote-absent-singular'):
                            result.color = '#000';
                            break;
                        case this.$t('com.file.interactive-voting-public-modal.vote-excluded'):
                        case this.$t('com.file.interactive-voting-public-modal.vote-excluded2'):
                            result.color = '#363532';
                            break;
                        default:
                            result.color = '#7cd1eb';
                            break;
                    }
                    return result.color;
                }
            },
            async closeModale(e) {
                try {
                    e.preventDefault();
                    this.$store.commit("setIsShowInteractiveVotingResultsModalStatus", false);
                    this.$store.commit("setIsResultsInVisualization", false);
                }
                catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .scroll-user-answers{
        max-height: calc(90vh - 300px);
    }

    .upr-res {
        border: solid 1px;
        padding: 10px;
        border-radius: 10px;
        border-color: silver;
        display: flex;
        flex-direction: row;
        column-gap: 10px;
        justify-content: center;
        align-items: center;

        .vote-for {
            background-color: rgb(121, 229, 99);
            color: black;
            text-decoration: none;
        }

        .vote-no {
            background-color: rgb(228, 0, 48);
            color: white;
            text-decoration: none;
        }

        .vote-abstain {
            background-color: rgb(255, 206, 86);
            color: black;
            text-decoration: none;
        }

        .vote-no-vote {
            background-color: rgb(192, 192, 192);
            color: black;
            text-decoration: none;
        }

        .vote-absent {
            background-color: rgb(0, 0, 0);
            color: white;
            text-decoration: none;
        }
    }

    .upr-res-special {
        border: solid 1px;
        //text-align: center;
        //padding: 15px;
        border-radius: 10px;
        border-color: silver;
        //text-align: left;
        width: max-content;
        display: flex;
        flex-direction: column;
/*        row-gap: 15px;*/

        b {
            padding: 15px 15px 10px 15px;
        }

        .option_summary {
            padding: 10px 15px;
        }

        :nth-child(even) {
            background: #e5e5e5;
        }
    }

    .special_result_option {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 5px;

        .special_result__query {
            flex-grow: 1;
        }

        &__row {
            padding: 5px;

            &__count {
                background: transparent !important;
                width: 17px;
            }
        }
    }

    .summary {
        &__col {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            &-double {
                display: flex;
                flex-direction: column;
            }

            &-single {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        &__row {
            margin-bottom: 24px;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;

            &-double {
                display: flex;
                justify-content: space-between;
                margin-bottom: 24px;
                align-items: center;
                column-gap: 12px;
            }
        }

        .vote-yes-background {
            background-color: #79e563;
            font-weight: bold;
        }

        .vote-no-background {
            background-color: #e40030;
            font-weight: bold;
        }

        .vote-abstain-background {
            background-color: #ffce56;
            font-weight: bold;
        }
    }



    .download-button {
        float: right;
        margin: 5px;
        padding: 10px;
        //width: 100px;
        height: 40px;
    }

    .download-button-eye {
        float: right;
        margin: 5px;
        padding: 10px;
        width: 40px;
        height: 40px;
    }

    .result-info-msg {
        margin-top: 15px;
        font-size: 24px;
    }

    .msg-result {
        text-align: center;
        padding: 15px;
        font-size: 16px;
    }

    .msg-result-excluted {
        text-align: center;
        padding: 5px;
        margin-top: 10px;
        font-size: 14px;
    }

    .results {
        display: flex;
        flex-wrap: wrap;
        row-gap: 10px;
        column-gap: 10px;
        justify-content: center;
    }

    .uprawniony {
        display: inline-block;
        padding: 8px;
        font-size: 1.1em;
        font-weight: 250;
    }


    .voting {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        background: #00082c75;
        z-index: 9;
    }

    .voting-form {
        padding: 15px 56px;
        background: linear-gradient(146.23deg, #f4f8ff 0%, #ffffff 100%);
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: 24px 40px 120px rgba(0, 8, 44, 0.32);
        border-radius: 12px;
        max-height: 100vh;
        max-width: 95vw;
        
        &__form-wrapper {
            max-height: 90vh;
            overflow-y: auto;
            max-width: 100vw;
            display: flex;
            flex-direction: column;
            row-gap: 20px;

            &::-webkit-scrollbar {
                width: 12px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #b5b8bd;
                border-radius: 30px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #b5b8bd;
            }

            &::-webkit-scrollbar-track {
                background: #ffffff;
                border: 0.8px solid #dce4ee;
                border-radius: 30px;
                box-shadow: inset 0px 0px 0px 0px #f0f0f0;
            }

            .available-users {
                display: flex;
                flex-wrap: wrap;
                column-gap: 10px;
                row-gap: 10px;
                //justify-content: center;


                .user {
                    //width: 180px;
                    display: flex;
                    column-gap: 10px;
                    //cursor: pointer;
                    //align-items: center;
                    background-color: #e5e5e5;
                    padding: 5px;
                    //text-align: center;

                    .user-avatar img {
                        width: 50px;
                        vertical-align: middle;
                    }

                    .user-data .user-name {
                        font-size: 1.1em;
                        font-weight: 300;
                    }
                }

                .user.absent {
                    background: #000 !important;
                    color: white;
                }

                .user.excluded {
                    background: #363532 !important;
                    color: white;
                    text-decoration: line-through;
                    font-size: 14px;
                }

                .user.vote-for {
                    background: #79e563 !important;
                }

                .user.vote-against {
                    background: #e40030 !important;
                    color: white !important;
                }

                .user.vote-abstain {
                    background: #ffce56 !important;
                }

                .user.vote-hidden {
                    background: #7cd1eb !important;
                }
            }
        }

        &__exit-btn {
            border: 0px;
            background-color: transparent;
        }

        &__title {
            align-items: start;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            span {
                font-weight: 400;
                font-size: 17px;
                line-height: 128%;
                color: #00082c;
            }

            &--small {
                font-size: 17px;
                border-bottom: 0px;
                padding-bottom: 16px;
                margin: 0px;
            }

            &--no-padding {
                padding: 0px;
            }
        }
    }

    .voting-special-wrapper
    {
        .summary__row-double{
            align-items: start;
        }
    }
    .voting-public {
        .voting-form {
            max-width: 95vw;
            z-index: 21;
        }

        .upr-res {
            font-size: 1.3em;
        }

        .voting-form__form-wrapper {
            .available-users {
                .user {
                    padding: 10px 10px;

                    .user-data {
                        .user-name {
                            font-size: 1.3em;
                            font-weight: 400;
                        }
                    }
                }
            }
        }
    }

    .result-without-chart {
        .user {
            width: 180px;
            align-items: center;
            min-height: 64px;
            padding: 5px 10px !important;

            .user-data {
                .user-name {
                    font-size: 1.5em !important;
                    font-weight: 450 !important;
                }
            }
        }
    }

    .option-result{
        border: 1px dotted #c0c0c0;
        padding: 5px 10px;
        border-radius: 10px;

        &__name {
            font-size: 1.2em;
            font-weight: bold;
        }
    }
</style>
